import { t } from "@repo/translation";
import { type IIToastContext, getDebugMessage } from "@repo/utils";

import { saveOpportunity, updateOpportunityStage } from "./opportunity";
import { type StagesEnum } from "./stagesEnum";
import { type UpdateOpportunity } from "./types";

export const updateProject = (
  newOpportunity: UpdateOpportunity,
  updateToast: IIToastContext["updateToast"]
) => {
  return saveOpportunity(newOpportunity)
    .then(() => {
      updateToast({
        id: newOpportunity.id,
        title: t("prompt.project_saved"),
      });
    })
    .catch((e) => {
      updateToast({
        id: newOpportunity.id,
        title: t("prompt.project_saved_failed"),
        message: getDebugMessage(e),
        type: "error",
      });
    });
};

export const updateProjectStage = async (
  opportunityId: number,
  stage: StagesEnum,
  updateToast: IIToastContext["updateToast"]
) => {
  try {
    await updateOpportunityStage(opportunityId, stage);
    updateToast({
      id: opportunityId,
      title: t("prompt.stage_updated"),
    });
  } catch (e) {
    updateToast({
      id: opportunityId,
      title: t("prompt.stage_update_failed"),
      message: getDebugMessage(e),
      type: "error",
    });
  }
};
